export const STORE_NAME = 'core/blocks';
